import React from "react";
import PropTypes from "prop-types";
import { Button } from "components/common/button";
import styles from "components/upload-documents/cancel-processing-modal.scss";
import { documentPropType } from "custom-prop-types";

export const CancelProcessingModal = ({
  focusedDocument,
  isVisible,
  onCancelProcessing
}) => {
  if (!isVisible || focusedDocument === null) {
    return null;
  }
  return (
    <div className={ styles["cancel-processing-container"] }>
      <div className={ `${styles["cancel-processing-content"]} manual6` }>
        <h3>Processing...</h3>
        <div>
          <p>This document is currently going through data verification</p>
          <div className={ styles["button-group"] }>
            <Button danger onClick={ () => { onCancelProcessing(focusedDocument); } }>Cancel Processing</Button>
            <span className={ styles.small }>to enter data manually</span>
          </div>
        </div>
      </div>
    </div>
  );
};

CancelProcessingModal.defaultProps = {
  focusedDocument: null
};

CancelProcessingModal.propTypes = {
  focusedDocument: documentPropType,
  isVisible: PropTypes.bool.isRequired,
  onCancelProcessing: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/upload-documents/cancel-processing-modal.jsx